import { render, staticRenderFns } from "./fileView.vue?vue&type=template&id=f46838d6&"
import script from "./fileView.vue?vue&type=script&lang=js&"
export * from "./fileView.vue?vue&type=script&lang=js&"
import style0 from "./fileView.vue?vue&type=style&index=0&id=f46838d6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports